export const STORAGE = {
    AUTH_KEY: `auth`,
    LAST_LOCATION_KEY: `last_location`,
    PREFIX: `taste_recovery:`,
    HOME_KEY: `home`,
    TOUR_KEY: `tour`,
    REMEMBER_ME_KEY: `remember_me`,
};
